/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum InvoiceCaseResult {
  Error = 0,
  Success = 1,
  CaseNotFound = 2,
  RequestValidationFailed = 3,
  TenantNotFound = 4,
  EmptyInvoice = 5,
  InvoiceDataNotModifiable = 6,
  InvoicingArticlesNotSetForTenant = 7,
  UserIsNotCaseManager = 8,
  InvoiceRecipientNotFound = 9,
  ArticleNotFound = 10,
}
